import { Location } from "history";
import React, { ComponentClass, FunctionComponent } from "react";
import { Route, RouteComponentProps, match, matchPath } from "react-router-dom";

export interface NavItem {
    path: string | string[];
    getURL?: (match: match<any> | null, location: Location<any>) => string;
    title: React.ReactNode | ((props: RouteComponentProps) => React.ReactNode);
    description?: JSX.Element;
    component: ComponentClass<any> | FunctionComponent<any>;
    children?: NavItem[];
    includeInMenu?: boolean;
    displayFullWidth?: boolean;
    buildAsComponent?: boolean;
    exact?: boolean;
}

export function getCurrentNavItem(navigation: NavItem, routerLocation?: Location<any>): NavItem | undefined {
    let result: NavItem | undefined;

    const location = routerLocation || window.location;

    const match = matchPath(location.pathname, {
        path: navigation.path,
        exact: navigation.exact === undefined ? true : navigation.exact
    });

    if (match) {
        result = navigation;
    } else if (navigation.children?.length) {
        navigation.children.forEach(function(item) {
            if (result) {
                return;
            }

            result = getCurrentNavItem(item, routerLocation);
        });
    }

    return result;
}

export function hasNavigation(items?: NavItem[]): boolean {
    if (items) {
        for (let i = 0; i < items.length; i++) {
            const includeInMenu = items[i].includeInMenu == null ? true : items[i].includeInMenu;

            if (includeInMenu) {
                return true;
            }

            if (items[i].children?.length && hasNavigation(items[i].children)) {
                return true;
            }
        }
    }

    return false;
}

export function getSinglePath(path: string | string[]): string {
    if (Array.isArray(path)) {
        return path[0];
    }

    return path;
}

export function getKeyName(path: string | string[]): string {
    if (Array.isArray(path)) {
        return path.join("|");
    }

    return path;
}

export function getRoutes(navigation: NavItem, allowPath: (path: string) => boolean): React.ReactNode {
    const path = getSinglePath(navigation.path);

    if (!allowPath(path)) {
        return null;
    }

    return (
        <React.Fragment>
            <Route path={navigation.path} component={navigation.component} exact={navigation.exact === undefined ? true : navigation.exact} />
            {!!navigation.children?.length && navigation.children.map(item => <React.Fragment key={getKeyName(item.path)}>{getRoutes(item, allowPath)}</React.Fragment>)}
        </React.Fragment>
    );
}
